import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AUDIT_MODULE } from '../../../../services/audit-log.service';
import { EditContractDataService } from '../../../../services/edit-contract-data.service';
import { HistoryTabComponent } from '../../../../../@shared/components/innform-question-sidepanel/tabs/history/history-tab.component';

@Component({
    selector: 'app-history-tab-wrapper',
    standalone: true,
    imports: [CommonModule, HistoryTabComponent],
    template: `
        <app-history-tab class="block h-full w-full" [auditModule]="AUDIT_MODULE.DOCUMENT" [filter]="{
                documentId: contractId()
            }"></app-history-tab>
    `,
})
export class HistoryTabWrapperComponent {
    AUDIT_MODULE = AUDIT_MODULE;

    constructor(public dataService: EditContractDataService) { }

    // Use getter methods to access computed signals from the service - these will auto-update!
    get contractId() { return this.dataService.contractId; }
}

